<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div *ngIf="this.label != null" class="col-md-12">
      <div  class="form-label" >
        {{this.label}}
        <span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span>
        <span *ngIf="this.tooltip != null" class="mt-1">
          <app-help-tooltip id="{{this.propertyId+'Tooltip'}}" [tooltipMessage]="this.tooltip"></app-help-tooltip>
        </span> 
      </div> 
    </div>
    <div *ngIf="this.subText != null" class="col-md-12">
      <div [innerHTML]="this.subText"></div>
    </div>      
  </div>

  <div class="row">       
    <div class="col">
      <div *ngIf="this.checkAllMessage != null" class="col-md-12">
        {{this.checkAllMessage}}
      </div>  
      <div *ngFor="let d of this.listData;">
        <label class="container-checkbox mt-3">
          <span style="font-weight: normal;" class="ml-2">{{d.display}}</span>
          <input id="{{this.propertyId}}" type="checkbox" name="{{d.code}}" [checked]="d.checked" [disabled]="d.disabled"
            (click)="this.userAction(d.code, $event.target.checked)">
          <span class="checkmark-checkbox"></span>
        </label>
      </div>     
    </div>      
  </div>

</div>